import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const fetcher = () => TablaComunService.getAsSelect(TiposTablaComunConstant.MOTIVOGUIAREMISION).then(({ data }) => data)

const MotivaGuiaRemisionSelect = props => {
  const { data: motivos } = useSwr('select_motivoGuiaRemision', fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  return (
    <Form.Select {...props}>
      <option value=''>Seleccionar</option>
      {motivos.map((val, key) => (
        <option key={key} value={val._id}>
          {val.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(MotivaGuiaRemisionSelect)
